<template>
  <v-row class="area-form">
    <v-col cols="2" class="ma-0">
      <p class="headline">{{ label }}</p>
    </v-col>
    <v-col class="ma-0">
      <v-textarea
        class="ma-0 area__statement"
        :label="tag"
        auto-grow
        v-model.trim="item"
        type="text"
        :id="label"
        required
        :hide-details="true"
        :color="color"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
export default {
  name: "PropositionRow",
  props: {
    label: String,
    tag: String,
    color: String,
    value: String,
  },
  data() {
    return {
      item: this.value,
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
  },
};
</script>
